import { Category } from "./category";

export class NewsContent{
    constructor(data){
        this.id = data.id;
        this.category = new Category(data.category_data);
        this.title = data.title;
        this.title_eng = data.title_eng;
        this.description = data.description;
        this.description_eng = data.description_eng;
        this.date = data.date;
        this.image = data.image;
        this.attachments = data.attachments;
        this.slug = data.slug;
    } 
}
